import { parseDate } from "@internationalized/date";

export function formatDateToBR(date: string | Date) {
  return new Date(date).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
}

export function formatDateToUTC(date: string | Date) {
  return new Date(date).toLocaleDateString("pt-BR", { timeZone: "UTC" });
}

export function formateDateToDatepicker(date: string | Date) {
  if (!date) return "";
  function formateDate() {
    return parseDate(date.toString().split("T")[0]);
  }

  const formattedDate = date.toString().includes("-") ? formateDate() : date;

  return formattedDate;
}

export function formatDateToUS(date: string) {
  const year = date.split("/")[2];
  const month = date.split("/")[1];
  const day = date.split("/")[0];
  return `${year}-${month}-${day}`;
}

export function formatDateToTimeBR(date: string | Date) {
  return new Date(date).toLocaleTimeString("pt-BR", { timeZone: "America/Sao_Paulo", hour12: false });
}

export function formatTimeFromISO(date: string | Date): string {
  const dateString = date instanceof Date ? date.toISOString() : date.toString();

  const timePart = dateString.substring(11, 19);

  if (!/^(\d{2}:){2}\d{2}$/.test(timePart)) {
    return "";
  }

  return timePart;
}

export function formatPhoneNumber(rawValue?: string) {
  return rawValue?.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}

export function formatToUTC(value: Date) {
  return Date.UTC(
    value.getFullYear(),
    value.getMonth(),
    value.getDate(),
    value.getHours(),
    value.getMinutes(),
    value.getSeconds()
  );
}
